import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { UserService } from 'app/services/user.service';
import { LockService } from 'app/services/lock.service';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';

enum CurrentState {
    ENTER_EMAIL = 0,
    LOADING_EMAIL,
    SELECT_COMPANY,
    ENTER_PASSWORD,
    LOADING_PASSWORD,
    ENTER_CODE,
    LOADING_CODE,
    LOGIN_WITH_TOKEN
}

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    loginForm: FormGroup;
    currentState: CurrentState = CurrentState.ENTER_EMAIL;
    returnUrl: string;
    currentOperation: Subscription = null;
    companies = [];
    invalidToken: boolean = false;
    @ViewChild('forgetpasswordpopover', { static: true }) forgetpasswordpopover: ModalDirective;
    forgetpasswordmsg: string;
    resetPassword: boolean = true;
    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router, private _validationHandler: ValidationHandler,
        private userService: UserService,
        private lockService: LockService,
        private ecoDocsTitleService: EcoDocsTitleService
    ) { }

    ngOnInit() {
        this.ecoDocsTitleService.setTitle('Login', false);
        this.loginForm = this.formBuilder.group({
            email: [''/*, Validators.required*/],
            password: [''],
            fqdn: [''],
            code: ['']
        });

        // get return url from route parameters or default to '/'        
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';
        if (this.returnUrl == '/logout') {
            this.returnUrl = '/home';
        }
        let redirectUrl = this.route.snapshot.queryParams['redirectUrl'] || null;

        if ( ( (this.route.snapshot.queryParams['token'] && this.route.snapshot.queryParams['email']) || 
                this.route.snapshot.queryParams['access_token']
                ) &&
            this.route.snapshot.queryParams['fqdn']) {
            this.currentState = CurrentState.LOGIN_WITH_TOKEN;
                
            const login$ = (this.route.snapshot.queryParams['token'])?  this.userService.loginWithToken(this.route.snapshot.queryParams['email'],
                                                                            this.route.snapshot.queryParams['token'],
                                                                            this.route.snapshot.queryParams['fqdn']) :
                                                                        this.userService.setToken(this.route.snapshot.queryParams['access_token'],
                                                                            this.route.snapshot.queryParams['fqdn']);
            this.currentOperation = login$
                .pipe(first())
                .subscribe(
                    data => {
                        if (redirectUrl) {
                            window.location.href = redirectUrl;
                        } else {
                            this.router.navigateByUrl(this.returnUrl);
                        }
                    },
                    error => {
                        /*this.alertService.error(error);*/
                        // this.loading = false;
                        this.invalidToken = true;
                        this.currentState = CurrentState.ENTER_EMAIL;
                    });
        }
    }

    onBackClicked(event: Event) {
        event.preventDefault();

        if ((this.currentState == CurrentState.ENTER_PASSWORD && this.companies.length > 1)) {
            this.currentState--;
        }
        else
            this.currentState -= 3;
    }

    isProgressVisible(): boolean {
        return this.currentState == CurrentState.LOADING_EMAIL ||
            this.currentState == CurrentState.LOADING_PASSWORD ||
            this.currentState == CurrentState.LOGIN_WITH_TOKEN ||
            this.currentState == CurrentState.LOADING_CODE;
    }

    onSubmit() {
        this.invalidToken = false;
        if (this.currentState == CurrentState.SELECT_COMPANY && this.loginForm.controls["fqdn"].value == "") {
            this.loginForm.controls["fqdn"].setErrors(["Please select a company"])
            return;
        }
        if (this.currentState == CurrentState.ENTER_EMAIL && this.loginForm.controls["email"].value == "") {
            return;
        }

        this.currentState += 1;

        if (this.currentState == CurrentState.LOADING_EMAIL) {
            /** @todo get the user's company */
            this.currentOperation = this.userService.getCompanies(this.loginForm.get('email').value)
                .pipe(first())
                .subscribe(
                    response => {
                        this.companies = response.companies;
                        if (this.companies.length == 1) {
                            // we have a winner
                            this.loginForm.get('fqdn').setValue(this.companies[0].fqdns[0]);
                            this.currentState += 2;
                        } else {
                            this.currentState++;
                        }
                    },
                    error => {
                        /*this.alertService.error(error);*/
                        //this.loading = false;
                        this.currentState = CurrentState.ENTER_EMAIL;
                        this._validationHandler.serverValidationHandler(error, this.loginForm);

                    });

        }
        else if (this.currentState == CurrentState.LOADING_PASSWORD) {
            // stop here if form is invalid
            if (this.loginForm.invalid) {
                /** @todo */
                this.currentState = CurrentState.ENTER_PASSWORD;
                this._validationHandler.onSubmitCheck(this.loginForm);
                return;
            }
            else {
                this.attemptLogin();
            }
        }
        else if (this.currentState == CurrentState.LOADING_CODE) {
            // stop here if form is invalid
            if (this.loginForm.invalid) {
                this.currentState = CurrentState.ENTER_CODE;
                this._validationHandler.onSubmitCheck(this.loginForm);
                return;
            }
            else {
                this.attemptLogin();
            }
        }
    }
    attemptLogin() {
        this.currentOperation = this.userService.login(this.loginForm.get('email').value, this.loginForm.get('password').value, this.loginForm.get('fqdn').value, this.loginForm.get('code').value)
        .pipe(first())
        .subscribe(
            data => {
                this.router.navigateByUrl(this.returnUrl);
                this.lockService.isLockScreenActive = false;
                localStorage.setItem('lockedScreen', 'false');
            },
            error => {
                var errorsObj = (error.errors || (error.error && error.error.errors) || {});
                if (this.currentState == CurrentState.LOADING_PASSWORD && errorsObj.code && Object.keys(errorsObj).length == 1) {
                    this.currentState = CurrentState.ENTER_CODE;
                } else {
                    this.currentState--;
                    this._validationHandler.serverValidationHandler(error, this.loginForm);
                }
            });
    }
    forgetpassword() {
        this.resetPassword = false;
        this.userService.sendResetPasswordMail(this.loginForm.get('fqdn').value, this.loginForm.get('email').value).subscribe(res => {
            this.resetPassword = true;

            this.forgetpasswordmsg = "Password reset link sent successfully, please check your email address."
            this.forgetpasswordpopover.show();

        }, err => {
            this.resetPassword = true;

            this.forgetpasswordmsg = err.message;
            this.forgetpasswordpopover.show();

        });
    }

}
